<template>
  <div class="guarantor--wrapper--bg">
    <LockLoader v-if="isLoading" :text="loadingMessage" asset="logo-alt.svg" />

    <div v-else class="guarantor--wrapper">
      <div class="logo">
        <Asset
          name="logo.svg"
          alt="Logo Parcelex"
          title="Logo Parcelex"
        />
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import LockLoader from '@/components/common/LockLoader.vue';
import Asset from '@/components/common/Asset.vue';

import Logger from '../../../lib/logger';

export default {
  name: 'guarantor-wrapper',
  computed: {
    ...mapState('guarantor', [
      'nextPage',
      'isLoading',
      'loadingMessage',
    ]),
  },
  methods: {
    ...mapActions('guarantor', [
      'getGuarantorApplication',
      'setLoading',
    ]),
    ...mapActions('auth', ['setToken']),
  },
  async mounted() {
    const {
      guarantorApplicationId,
      authToken,
    } = this.$route.query;

    await this.setToken({ token: authToken });
    try {
      await this.getGuarantorApplication({ guarantorApplicationId });

      await this.$router.replace({
        name: this.nextPage,
        query: this.$route.query,
      });
    } catch (err) {
      Logger.error(err);
      this.setToken({ token: null });
    }

    this.setLoading({ isLoading: false });
  },
  components: {
    Asset,
    LockLoader,
  },
};

// no load tem q bater com o id, se não tiver vai pra pagina de erro
</script>

<style lang="scss" scoped>
  .guarantor--wrapper--bg {
    box-sizing: border-box;

    width: 100%;
    min-height: 100vh;

    @media (min-width: $breakpoint-large) {
      padding: 24px 0 30px 0;

      background-color: #F1F5F9;
    }
  }

  .guarantor--wrapper {
    background-color: #FFFFFF;
    padding: 24px;

    @media (min-width: $breakpoint-large) {
      box-sizing: border-box;
      margin: 0 auto;
      max-width: 600px;

      border: 1px solid #CBD5E1;
      border-radius: 8px;
    }
  }

  .logo {
    @media (min-width: $breakpoint-large) {
      display: flex;
      justify-content: center;
    }
  }
</style>
